<template>
  <div class="exchange-wrapper">
   <tiga-notice />
    <div :class="['exchange-container', isShowDetail ? 'next' : '']">
      <div class="content-item">
        <exchange-page ref="exchange" />
      </div>
      <div class="content-item">
        <take-order v-if="isShowDetail" :id="orderId" />
      </div>
    </div>
  </div>
</template>

<script>
import tigaNotice from '@/components/tiga-notice.vue';
import ExchangePage from './exchange.vue';
import takeOrder from './take-order/take-order.vue';
import { mapState } from 'vuex';
export default {
  components: {
    tigaNotice,
    ExchangePage,
    takeOrder,
  },
  data() {
    return {
      isExchangeInited: false,
      isNoviceGuideShow: false,
    };
  },
  computed: {
    ...mapState(['userInfo', 'isLogin']),
    isShowDetail() {
      return this.$route.path === '/exchange/takeOrder';
    },
    orderId() {
      return this.$route.query.id || '';
    },
  },
  watch: {
    $route(newRoute) {
      if (newRoute.name === 'index') {
        this.initExchange();
        this.$emit('check-guide');
      }
    },
  },
  mounted() {
    this.initExchange();
    this.$emit('check-guide');
  },
  methods: {
    initExchange() {
      if (
        this.$route.name === 'index' &&
        !this.isExchangeInited &&
        this.$refs.exchange
      ) {
        this.isExchangeInited = true;
        this.$refs.exchange.init();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.exchange-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.exchange-container {
  display: flex;
  width: 200vw;
  height: 100%;
  transform: translate3d(0, 0, 0);
  will-change: transform;

  &.next {
    transform: translate3d(-50%, 0, 0);
  }
}

.content-item {
  position: relative;
  width: 100vw;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
